import {ChangeDetectionStrategy, Component, EventEmitter, Output} from "@angular/core";

@Component({
  selector: 'int-clear-action-default',
  template: `
    <button class="clear-btn" (click)="onClearHandler($event)">
      <int-icon name="close" size="0.8rem"></int-icon>
    </button>
  `,
  styles: [`
    .clear-btn {
      padding: 0.6rem;
      color: currentColor;
      position: relative;
      transition: 0.3s ease;
      transform-origin: center;
    }
    .clear-btn:hover {
       transform: rotate(90deg);
     }
    .clear-btn:focus-visible {
       box-shadow: 0 0 0 0.1rem currentColor;
     }
    .clear-btn:active {
      transform: rotate(90deg) scale(1.1);
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntClearActionDefaultComponent {

  @Output() onClear = new EventEmitter<Event>();

  onClearHandler(event: Event) {
    this.onClear.emit(event)
  }
}
